import { UsersList as UsersListComponent } from './UsersList.component';
import { connector } from './UsersList.connector';

export const UsersList = connector(UsersListComponent);
